// https://vuex.vuejs.org/en/state.html

import {MerchantData, Outlet} from "../../entities";
//import state from "../state";

const state = () => {
    return {
        merchant: {},
        documents: [],
        merchant_relation:{},
        application_relation:{},
        parameters: {},
        topTabsConfig: [],
        user: {},
        merchant_users: {},
        outletInFocus: new Outlet(),
        application_root_path: '/application/add/',
        quote_root_path: '/application/add/',
        applicationPageTitle: 'tell_us_about_your_business',
        page_configuration: {},
        alliance: {},
        substatuses: [],
        application_users: {},
        quote: {},
        is_loading: false,
        outlets: [],
        merchant_hierarchy: {},
        matched_packages: {},
        merchant_hierarchy_configuration_templates: {},
        quote_lock: false,
        page_config_id: '',
        equipment_offerings: [],
        acquiring_offerings: [],
        criteria: {},
        online_offerings: [],
        equipment_offer: {}, //.what we display on the UI
        acquiring_offer: [], //.what we display on the UI
        online_offer: {}, //.what we display on the UI
        validation_errors: [],
        can_view: false,
        can_edit: false,
        application_tabs: [],
        disable_go_back_warning_modal: false,
        error_message: '',
        paypal_boarding: {},
        loading_document_upload: false,
        business_info_subtabs:[],
        business_details_subtabs:[],
        redirect_to_error_tab: false,
        portal_tabs: [
            {
                display: true,
                is_active: true,
                is_open: false,
                is_complete: false,
                is_quote_tab: true,
                short_label: "business_info",
                label: "tab_business_info_equipment_pricing",
                lang_key: "tab_business_info_equipment_pricing",
                tab_id: "tab_business_information",
                url: "business/",
                subitems: [
                    {
                        // class: "btn btn-default",
                        display: true,
                        // icon: "flaticon-cogwheels12",
                        is_active: true,
                        is_open: false,
                        entity_type: 1,
                        component_name: 'BusinessInfo',
                        short_label: "business",
                        label: "tab_business_information",
                        // lang_key: "tab_business_information",
                        tab_id: "tab_business_information",
                        url: "",
                        path: '',
                    },
                    {
                        // class: "btn btn-default",
                        display: true,
                        // icon: "flaticon-cogwheels12",
                        is_active: true,
                        is_open: false,
                        short_label: "equipment",
                        component_name: 'Equipments',
                        label: "equipment",
                        tab_id: "tab_equipment",
                        url: "products/",
                        path: "products/",
                    }, {
                        // class: "btn btn-default",
                        display: true,
                        // icon: "flaticon-cogwheels12",
                        is_active: true,
                        is_open: false,
                        short_label: "pricing",
                        component_name: 'Pricing',
                        label: "pricing",
                        tab_id: "tab_pricing",
                        url: "pricing/",
                        path: "pricing/",
                    },
                ]
            },
            {
                display: true,
                is_active: false,
                is_open: false,
                is_complete: false,
                is_application_tab: true,
                short_label: "business_details",
                label: "tab_business_trading_details",
                lang_key: "tab_business_trading_details",
                tab_id: "tab_business_details",
                url: "business_details/",
                subitems: [
                    {
                        display: true,
                        is_active: true,
                        is_open: false,
                        entity_type: 1,
                        short_label: "business_details",
                        label: "tab_business_details",
                        tab_id: "tab_business_details",
                        url: "",
                    },
                    {
                        display: true,
                        is_active: true,
                        is_open: false,
                        short_label: "trading",
                        label: "trading",
                        tab_id: "tab_outlets",
                        url: "trading/",
                    },
                    {
                        display: true,
                        is_active: true,
                        is_open: false,
                        short_label: "tab_principals",
                        label: "tab_principals",
                        tab_id: "tab_principals",
                        url: "principals/",
                    },
                ]
            },
            {
                display: true,
                is_active: false,
                is_open: false,
                is_complete: false,
                is_application_tab: true,
                short_label: "tab_documents",
                label: "tab_supporting_documents_upload",
                lang_key: "tab_supporting_documents_upload",
                tab_id: "tab_documents",
                url: "documents/",
            },
            {
                display: false,
                is_active: false,
                is_open: false,
                is_complete: false,
                is_application_tab: true,
                short_label: "tab_documents",
                label: "tab_supporting_documents_upload",
                lang_key: "tab_supporting_documents_upload",
                tab_id: "tab_documents",
                url: "upload_documents/",
            },
            {
                display: true,
                is_active: false,
                is_open: false,
                is_complete: false,
                is_application_tab: true,
                short_label: "review_signature",
                label: "tab_review_signature",
                lang_key: "tab_review_signature",
                tab_id: "tab_review_signature",
                url: "review/",
            },
        ],

        // outlet_relation: {},
        // outlet_form_data: {},
        // outletSummary: {},
        // chains: {},
        // billings: {},
        // merchant_ref: '',
        // current_account_parent: {},
        // daily_accounts: [],
        // last_chain_path: '',
        // redirect_to_error_tab: false,
        // last_outlet_paths: {},
        // outletInFocus: {},
        // principalInFocus: {},
        // snapshot_input: {},
        // current_node_type:  '',
        // validation_errors: {},
        // is_provider: false,
        // logged_in_user_id: '',
    }
}
export default state;
